'use strict';

module.exports = hardBreak;

var u = require('unist-builder');

/* Transform an inline break. */
function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')];
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/break.js
// module id = 960
// module chunks = 0